import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import Env from '@ridango/core/env';
import { AccountTicketsService } from '@ridango/components/lib/account-tickets';

@Injectable({
    providedIn: 'root'
})
export class MyTicketsService {
    constructor(
        @Inject('ENV') private env: Env,
        private http: HttpClient,
        private datePipe: DatePipe,
        private accountTicketsService: AccountTicketsService
    ) {}

    getCustomerTickets(token: string = null): Observable<any> {
        let options = {};
        if (token) {
            const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
            options = {
                headers: headers
            };
        }
        // v2/8388608/tickets
        return this.http.get(`${this.env.API_BASE_URL}/${this.env.REGION_ID}/tickets`, options);
    }

    getCustomerTicketHistoryLatest(
        startDate: Date,
        endDate: Date,
        threshold: number = null,
        token: string = null
    ): Observable<any> {
        const start = this.datePipe.transform(startDate, 'yyyy-MM-dd');
        const end = this.datePipe.transform(endDate, 'yyyy-MM-dd');
        const channelParams = this.env.FILTER_PURCHASES_BY_CHANNEL
            ? {
                  channel: this.accountTicketsService.getChannel()
              }
            : {};
        let options = {};

        if (token) {
            const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
            options = {
                headers,
                params: {
                    ...channelParams
                }
            };
        }

        // v2/8388608/tickets/history/2018-01-30/2018-01-31?includeTicketsExpiredInGivenHours=24
        if (threshold) {
            options = {
                ...options,
                params: {
                    ...channelParams,
                    includeTicketsExpiredInGivenHours: threshold
                }
            };
        }
        return this.http.get(`${this.env.API_BASE_URL}/${this.env.REGION_ID}/tickets/history/${start}/${end}`, options);
    }

    fetchExtraZones(origin, destination): Observable<Zone[]> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/zones/origin/${origin}/destination/${destination}/extra_zones`;
        return this.http.get<Zone[]>(url);
    }

    fetchAllStationsExtraZones(origin, destination): Observable<Zone[]> {
        const url = `${this.env.CORE_API_URL}/partner/v2/service/zones/origin/${origin}/destination/${destination}/all_stations`;
        return this.http.get<Zone[]>(url);
    }
}

interface Zone {
    id: number;
    name: string;
}
